import { useCallback, useEffect, useState } from "react";
import {
  getFromLocalStorage,
  saveToLocalStorage,
  removeFromLocalStorage,
} from "@litres/utils";

// TODO: Переработать в рамках https://jira.mybook.tech/browse/ACQN-857
export const useLocalStorage = <T>(
  key: string,
  initialValue: T | null = null
) => {
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }

    const item = getFromLocalStorage(key) as T;

    return item ? item : initialValue;
  });

  useEffect(() => {
    const item = getFromLocalStorage(key) as T;

    setStoredValue(item ? item : storedValue);
  }, [key]);

  const setValue = useCallback(
    (value: T) => {
      try {
        const valueToStore =
          value instanceof Function ? value(storedValue) : value;
        setStoredValue(valueToStore);
        if (typeof window !== "undefined") {
          saveToLocalStorage({ [key]: valueToStore });
        }
      } catch (error) {
        console.log("useLocalStorage: saving store value error", error);
      }
    },
    [key, storedValue]
  );

  const removeValue = useCallback(() => {
    try {
      setStoredValue(null);
      if (typeof window !== "undefined") {
        removeFromLocalStorage(key);
      }
    } catch (error) {
      console.log("useLocalStorage: removing store value error", error);
    }
  }, [key]);

  return [storedValue, setValue, removeValue] as const;
};
